/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ConnecteRouteImport } from './routes/_connecte'
import { Route as ConnecteAGererRouteImport } from './routes/_connecte/a-gerer'
import { Route as ConnecteLieuxRouteImport } from './routes/_connecte/lieux'
import { Route as ConnectePlanningRouteImport } from './routes/_connecte/planning'
import { Route as ConnecteProfilRouteImport } from './routes/_connecte/profil'
import { Route as ConnecteRapportsRouteImport } from './routes/_connecte/rapports'
import { Route as ConnecteTypesSeanceRouteImport } from './routes/_connecte/types-seance'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as ConnecteUtilisateursIndexRouteImport } from './routes/_connecte/utilisateurs.index'
import { Route as ConnecteUtilisateursIdUtilisateurRouteImport } from './routes/_connecte/utilisateurs.$idUtilisateur'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnecteRoute = ConnecteRouteImport.update({
  id: '/_connecte',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnecteAGererRoute = ConnecteAGererRouteImport.update({
  id: '/a-gerer',
  path: '/a-gerer',
  getParentRoute: () => ConnecteRoute,
} as any)
const ConnecteLieuxRoute = ConnecteLieuxRouteImport.update({
  id: '/lieux',
  path: '/lieux',
  getParentRoute: () => ConnecteRoute,
} as any)
const ConnectePlanningRoute = ConnectePlanningRouteImport.update({
  id: '/planning',
  path: '/planning',
  getParentRoute: () => ConnecteRoute,
} as any)
const ConnecteProfilRoute = ConnecteProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => ConnecteRoute,
} as any)
const ConnecteRapportsRoute = ConnecteRapportsRouteImport.update({
  id: '/rapports',
  path: '/rapports',
  getParentRoute: () => ConnecteRoute,
} as any)
const ConnecteTypesSeanceRoute = ConnecteTypesSeanceRouteImport.update({
  id: '/types-seance',
  path: '/types-seance',
  getParentRoute: () => ConnecteRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnecteUtilisateursIndexRoute =
  ConnecteUtilisateursIndexRouteImport.update({
    id: '/utilisateurs/',
    path: '/utilisateurs/',
    getParentRoute: () => ConnecteRoute,
  } as any)
const ConnecteUtilisateursIdUtilisateurRoute =
  ConnecteUtilisateursIdUtilisateurRouteImport.update({
    id: '/utilisateurs/$idUtilisateur',
    path: '/utilisateurs/$idUtilisateur',
    getParentRoute: () => ConnecteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/a-gerer': typeof ConnecteAGererRoute
  '/lieux': typeof ConnecteLieuxRoute
  '/planning': typeof ConnectePlanningRoute
  '/profil': typeof ConnecteProfilRoute
  '/rapports': typeof ConnecteRapportsRoute
  '/types-seance': typeof ConnecteTypesSeanceRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/utilisateurs/$idUtilisateur': typeof ConnecteUtilisateursIdUtilisateurRoute
  '/utilisateurs/': typeof ConnecteUtilisateursIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/a-gerer': typeof ConnecteAGererRoute
  '/lieux': typeof ConnecteLieuxRoute
  '/planning': typeof ConnectePlanningRoute
  '/profil': typeof ConnecteProfilRoute
  '/rapports': typeof ConnecteRapportsRoute
  '/types-seance': typeof ConnecteTypesSeanceRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/utilisateurs/$idUtilisateur': typeof ConnecteUtilisateursIdUtilisateurRoute
  '/utilisateurs': typeof ConnecteUtilisateursIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_connecte': typeof ConnecteRouteWithChildren
  '/_connecte/a-gerer': typeof ConnecteAGererRoute
  '/_connecte/lieux': typeof ConnecteLieuxRoute
  '/_connecte/planning': typeof ConnectePlanningRoute
  '/_connecte/profil': typeof ConnecteProfilRoute
  '/_connecte/rapports': typeof ConnecteRapportsRoute
  '/_connecte/types-seance': typeof ConnecteTypesSeanceRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_connecte/utilisateurs/$idUtilisateur': typeof ConnecteUtilisateursIdUtilisateurRoute
  '/_connecte/utilisateurs/': typeof ConnecteUtilisateursIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/a-gerer'
    | '/lieux'
    | '/planning'
    | '/profil'
    | '/rapports'
    | '/types-seance'
    | '/auth/callback'
    | '/utilisateurs/$idUtilisateur'
    | '/utilisateurs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/a-gerer'
    | '/lieux'
    | '/planning'
    | '/profil'
    | '/rapports'
    | '/types-seance'
    | '/auth/callback'
    | '/utilisateurs/$idUtilisateur'
    | '/utilisateurs'
  id:
    | '__root__'
    | '/'
    | '/_connecte'
    | '/_connecte/a-gerer'
    | '/_connecte/lieux'
    | '/_connecte/planning'
    | '/_connecte/profil'
    | '/_connecte/rapports'
    | '/_connecte/types-seance'
    | '/auth/callback'
    | '/_connecte/utilisateurs/$idUtilisateur'
    | '/_connecte/utilisateurs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConnecteRoute: typeof ConnecteRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_connecte': {
      id: '/_connecte'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ConnecteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_connecte/a-gerer': {
      id: '/_connecte/a-gerer'
      path: '/a-gerer'
      fullPath: '/a-gerer'
      preLoaderRoute: typeof ConnecteAGererRouteImport
      parentRoute: typeof ConnecteRoute
    }
    '/_connecte/lieux': {
      id: '/_connecte/lieux'
      path: '/lieux'
      fullPath: '/lieux'
      preLoaderRoute: typeof ConnecteLieuxRouteImport
      parentRoute: typeof ConnecteRoute
    }
    '/_connecte/planning': {
      id: '/_connecte/planning'
      path: '/planning'
      fullPath: '/planning'
      preLoaderRoute: typeof ConnectePlanningRouteImport
      parentRoute: typeof ConnecteRoute
    }
    '/_connecte/profil': {
      id: '/_connecte/profil'
      path: '/profil'
      fullPath: '/profil'
      preLoaderRoute: typeof ConnecteProfilRouteImport
      parentRoute: typeof ConnecteRoute
    }
    '/_connecte/rapports': {
      id: '/_connecte/rapports'
      path: '/rapports'
      fullPath: '/rapports'
      preLoaderRoute: typeof ConnecteRapportsRouteImport
      parentRoute: typeof ConnecteRoute
    }
    '/_connecte/types-seance': {
      id: '/_connecte/types-seance'
      path: '/types-seance'
      fullPath: '/types-seance'
      preLoaderRoute: typeof ConnecteTypesSeanceRouteImport
      parentRoute: typeof ConnecteRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_connecte/utilisateurs/': {
      id: '/_connecte/utilisateurs/'
      path: '/utilisateurs'
      fullPath: '/utilisateurs/'
      preLoaderRoute: typeof ConnecteUtilisateursIndexRouteImport
      parentRoute: typeof ConnecteRoute
    }
    '/_connecte/utilisateurs/$idUtilisateur': {
      id: '/_connecte/utilisateurs/$idUtilisateur'
      path: '/utilisateurs/$idUtilisateur'
      fullPath: '/utilisateurs/$idUtilisateur'
      preLoaderRoute: typeof ConnecteUtilisateursIdUtilisateurRouteImport
      parentRoute: typeof ConnecteRoute
    }
  }
}

interface ConnecteRouteChildren {
  ConnecteAGererRoute: typeof ConnecteAGererRoute
  ConnecteLieuxRoute: typeof ConnecteLieuxRoute
  ConnectePlanningRoute: typeof ConnectePlanningRoute
  ConnecteProfilRoute: typeof ConnecteProfilRoute
  ConnecteRapportsRoute: typeof ConnecteRapportsRoute
  ConnecteTypesSeanceRoute: typeof ConnecteTypesSeanceRoute
  ConnecteUtilisateursIdUtilisateurRoute: typeof ConnecteUtilisateursIdUtilisateurRoute
  ConnecteUtilisateursIndexRoute: typeof ConnecteUtilisateursIndexRoute
}

const ConnecteRouteChildren: ConnecteRouteChildren = {
  ConnecteAGererRoute: ConnecteAGererRoute,
  ConnecteLieuxRoute: ConnecteLieuxRoute,
  ConnectePlanningRoute: ConnectePlanningRoute,
  ConnecteProfilRoute: ConnecteProfilRoute,
  ConnecteRapportsRoute: ConnecteRapportsRoute,
  ConnecteTypesSeanceRoute: ConnecteTypesSeanceRoute,
  ConnecteUtilisateursIdUtilisateurRoute:
    ConnecteUtilisateursIdUtilisateurRoute,
  ConnecteUtilisateursIndexRoute: ConnecteUtilisateursIndexRoute,
}

const ConnecteRouteWithChildren = ConnecteRoute._addFileChildren(
  ConnecteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConnecteRoute: ConnecteRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
